const excludedFlavorsImportantDetailsConfig = {
    adjustDetails: [
        'Afbestillingsforsikring til enkeltrejse',
        'Enkeltrejse',
        'Kennelforsikring',
        'Privat løsøre- og ansvarsforsikring',
        'Arbejdsskadeforsikring'
    ]
};

const excludedFlavoursCoveragesConfig = {
    adjustCoverages: [
        'Kennelforsikring',
        'Privat løsøre- og ansvarsforsikring',
        'Arbejdsskadeforsikring'
    ]
};

const excludedFlavoursSumsConfig = {
    adjustSums: [
        'Kennelforsikring',
        'Privat løsøre- og ansvarsforsikring',
        'Arbejdsskadeforsikring'
    ]
};

export {
    excludedFlavorsImportantDetailsConfig,
    excludedFlavoursCoveragesConfig,
    excludedFlavoursSumsConfig
};
